<template>
    <button class="btn" v-bind:class="htmlClass">
      <i class="cil-magnifying-glass"></i>
      <span>{{ txt }}</span>
    </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    txt: String,
    uLine: String,
  },
  computed: {
    htmlClass() {
      return `btn__special--${this.uLine}`;
    },
    icon() {
      return null;
    },
  },
};
</script>

<style>
.btn__special--info {
  border-bottom: 3px solid #00a3ff;
}
.btn__special--success {
  border-bottom: 3px solid #04b135;
}
.btn__special--warning {
  border-bottom: 3px solid #c6c263;
}
.btn__special--danger {
  border-bottom: 3px solid #c80000;
}
</style>